"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _util = require("@ux/util");
var _helpers = require("./helpers");
var constants = require('./constants');
const browser = typeof document !== 'undefined';

/**
 * Collection of cookies, read out cookie info_idp on construction.
 *
 * @Constructor Cookies.
 * @param {Object} options Optional configuration.
 * @api public
 */
class Cookies {
  constructor() {
    this.idp = {};
    this.getIdpProperty = (0, _helpers.get)(this.idp);
    this.updateRealm('idp');
    this.jomax = {};
    this.getJomaxProperty = (0, _helpers.get)(this.jomax);
    this.updateRealm('jomax');
  }

  /**
   * Get the customers shopper id from the cookie.
   *
   * @returns {String} Shopper id.
   * @api public
   */
  get shopperId() {
    return this.getIdpProperty('info_shopperId');
  }

  /**
   * Get the encrypted shopper ID from the ShopperId<plid> cookie
   * @param {String} env Environment (e.g. prod, test, dev)
   * @param {Number} plid Private label ID
   * @returns {String|Undefined} encrypted shopper ID or undefined
   * @public
   */
  getEncryptedShopperId(env, plid) {
    const cookieEnv = env === 'prod' ? '' : env || '';
    return _util.cookie.get(`${cookieEnv}ShopperId${plid}`) || undefined; // eslint-disable-line no-undefined
  }

  /**
   * Update the cached cookies values.
   * (For backwards compatibility since this was previously marked as public)
   *
   * @returns {Cookies} fluent interface.
   * @param {String} loggedOutCookieType The cookie type parse
   * @api public
   */
  updateIdp() {
    let loggedOutCookieType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return this.updateRealm('idp', loggedOutCookieType);
  }

  /**
   * Update the cached cookies values.
   *
   * @param {String} [realm='idp'] The authentication realm to update
   * @param {String} loggedOutCookieType The cookie type to parse
   * @returns {Cookies} fluent interface.
   * @api private
   */
  updateRealm() {
    let realm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'idp';
    let loggedOutCookieType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (!browser) {
      return this;
    }
    const titleCaseRealm = realm[0].toUpperCase() + realm.substr(1);
    switch (loggedOutCookieType) {
      case constants.CUSTO_SHOPPER_MER_COOKIE:
        this[realm] = _util.json.parse(_util.cookie.get(`cust_${realm}`)) || {};
        break;
      case constants.LOGGED_OUT_INFO_COOKIE:
        this[realm] = _util.json.parse(_util.cookie.get(`info_cust_${realm}`)) || {};
        break;
      default:
        this[realm] = _util.json.parse(_util.cookie.get(`info_${realm}`)) || {};
        break;
    }
    this[`get${titleCaseRealm}Property`] = (0, _helpers.get)(this[realm]);
    return this;
  }

  /**
   * Get the requested properties from the cookie for the specified realm.
   *
   * @param {Array} properties properties to extract.
   * @param {Object} replace Optional object with strings to replace.
   * @returns {Object} Collection of extracted properties.
   * @api public
   */
  getIdpProperties(properties, replace) {
    return Cookies.getRealmPropertiesFromObject(this.idp, properties, replace);
  }

  /**
   * Get the requested properties from the specified object
   *
   * @param {Object} obj The object to extract properties from
   * @param {Array} properties properties to extract.
   * @param {Object} replace Optional object with strings to replace.
   * @returns {Object} Collection of extracted properties.
   * @package
   */
  static getRealmPropertiesFromObject(obj, properties) {
    let replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const getProp = (0, _helpers.get)(replace);
    if (!Array.isArray(properties)) {
      properties = [properties];
    }
    return properties.reduce((result, property) => {
      if (Array.isArray(property)) {
        result[getProp(property[property.length - 1], true)] = property.reduce((o, i) => o && o[i], obj);
        const desiredProp = property[property.length - 1];
        if (obj[desiredProp] && !result[desiredProp]) {
          result[desiredProp] = obj[desiredProp];
        }
        return result;
      }
      result[getProp(property, true)] = obj[property];
      return result;
    }, {});
  }

  /**
   * Get the requested properties from the jomax cookie.
   *
   * @param {Array} properties properties to extract.
   * @param {Object} replace Optional object with strings to replace.
   * @returns {Object} Collection of extracted properties.
   * @api public
   */
  getJomaxProperties(properties, replace) {
    return Cookies.getRealmPropertiesFromObject(this.jomax, properties, replace);
  }
}
exports.default = Cookies;